import { LoadingButton } from '@mui/lab'
import { Box, BoxProps, Button } from '@mui/material'
import { useStyles } from './styles'

interface Props {
  accept?: {
    label: string
    click: () => void
    disabled?: boolean
    variant?: "text" | "contained" | "outlined"
  }
  cancel?: {
    label: string
    click: () => void
    disabled?: boolean
    variant?: "text" | "contained" | "outlined"
  }
  extraChildren?: JSX.Element
  customeStyles?: boolean
  isLoading?: boolean;
  autoHeight?: boolean
  boxProps?: BoxProps
}

const SimpleButtons = ({ accept, cancel, isLoading, customeStyles, autoHeight, boxProps, extraChildren }: Props) => {
  const styles = useStyles()
  return (
    <Box {...boxProps} sx={{ ...styles.container({ autoHeight: !!autoHeight }), ...boxProps?.sx }}>
      {!!cancel ? (
        <Button onClick={() => cancel?.click()} sx={customeStyles ? styles.customeBack : styles.Cbutton} variant={cancel?.variant ?? 'contained'} disabled={cancel?.disabled}>
          {cancel?.label}
        </Button>
      ) : <Box />}

      <Box sx={styles.endBtn}>
        {!!accept && (
          <LoadingButton loading={!!isLoading} onClick={() => accept?.click()} sx={customeStyles ? styles.customeSend : styles.Abutton} variant={accept?.variant ?? 'contained'} disabled={accept?.disabled}>
            {accept.label}
          </LoadingButton>
        )}

        {extraChildren}
      </Box>
    </Box>
  )
}

export default SimpleButtons
